import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Pagination, Select } from "antd";
import EmployeeCard from "./EmployeeCard";
import EmployeeLocationModal from "./EmployeeLocationModal";
import { companyID } from "../../../../auth";
import api from "../../../../api/axios";
import { useLocation, useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";

const EmployeeLocations = () => {
  const [searchParams] = useSearchParams();
  const employee_id = searchParams.get("employee_id");
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const loginEmployeeId = localStorage.getItem("employeeID");
  const company_id = companyID();
  const [employees, setEmployees] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get(
          `employees/employeeDetails/${company_id}?status=1`
        );
        setEmployees(
          response?.data?.filter((item) =>
            employee_id ? item.id == employee_id : item.id != loginEmployeeId
          )
        );
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    if (company_id) {
      fetchEmployees();
    }
  }, []);

  const paginatedEmployees = employees.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleCardClick = (employee) => {
    setSelectedEmployee(employee);
    setModalVisible(true);
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid position-relative">
        <Breadcrumbs
          maintitle={`${employeeName} Location`}
          title="Dashboard"
          subtitle="Location"
        />
        <Row>
          {paginatedEmployees.map((employee) => (
            <Col
              key={employee.id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              style={{ cursor: "pointer" }}
            >
              <EmployeeCard employee={employee} onClick={handleCardClick} />
            </Col>
          ))}
        </Row>

        <div className="d-flex justify-content-between align-items-center mt-4">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={employees.length}
            showSizeChanger
            onChange={handlePageChange}
            pageSizeOptions={["5", "10", "15", "20"]}
          />
        </div>

        {selectedEmployee && (
          <EmployeeLocationModal
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            employee={selectedEmployee}
          />
        )}
      </div>
    </div>
  );
};

export default EmployeeLocations;
